<template>
  <bottom-sheet :open="open" title="تماس با پشتیبانی" @close="$emit('close')">
    <div class="sh-head">
      <div class="iconcircle"><base-icon name="phone" /></div>
      <div class="stack gap-10">
        <h2>تماس با پشتیبانی</h2>
        <p>برای پیگیری یا رفع مشکل، با شماره‌ی زیر تماس بگیرید.</p>
      </div>
    </div>

    <div class="sup-num">
      <b dir="ltr">{{ display }}</b>
      <copy-button :value="phone" label="کپی شماره پشتیبانی" />
    </div>

    <div class="sh-foot">
      <button class="btn btn-outline" type="button" @click="$emit('close')">بستن</button>
    </div>
  </bottom-sheet>
</template>

<script>
import BottomSheet from "./BottomSheet.vue";
import BaseIcon from "./BaseIcon.vue";
import CopyButton from "./CopyButton.vue";
import { SUPPORT_PHONE, SUPPORT_PHONE_DISPLAY } from "@/constants";

/**
 * The support number, shown on desktop where a `tel:` link has nothing to hand off to.
 * The number is the whole content, so it gets its own emphasis and a copy affordance.
 */
export default {
  name: "SupportSheet",
  components: { BottomSheet, BaseIcon, CopyButton },

  props: {
    open: { type: Boolean, default: false },
    phone: { type: String, default: SUPPORT_PHONE },
    display: { type: String, default: SUPPORT_PHONE_DISPLAY },
  },
};
</script>

<style scoped>
.sup-num {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 18px;
  padding: 14px 16px;
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: 14px;
}

.sup-num b {
  font-size: 23px;
  font-weight: 800;
  letter-spacing: 0.03em;
  font-variant-numeric: tabular-nums;
  color: var(--foreground);
}
</style>
